import React from 'react'
import {useTranslation} from 'react-i18next'
import {List} from 'antd'
import {Card, DateTimeLabel, Description, Text} from '@/components'
import {TitleWithStatus} from '@/components/composite/TitleWithStatus'
import {PaymentLink} from '@/api'
import {
    getPayByLinkPaymentStatusIconType,
    getPayByLinkPaymentStatusName,
    getPayByLinkPaymentStatusTagType
} from '~/code/pages/PayByLink/services'
import {getAmountWithCurrentCurrency} from '@/utils'
import {MobileListProps} from './props'
import styles from './styles.scss'

export type ListItem = PaymentLink & {
    key?: string
    customer?: string
    date?: string
    paymentMethod?: string
    paymentMethodType?: string
}

export const MobilePayByLinkPaymentList: React.FC<MobileListProps<ListItem>> = ({
    dataSource,
    listExtra,
    isLoading,
    onItemClick
}) => {
    const {t} = useTranslation()
    return (
        <List
            loading={isLoading}
            itemLayout={'horizontal'}
            dataSource={dataSource || []}
            renderItem={(item) => {
                const extra = listExtra(item)

                return (
                    <Card
                        key={item.key || item.id}
                        title={
                            <TitleWithStatus
                                statusProps={{
                                    status: getPayByLinkPaymentStatusName(item.status),
                                    type: getPayByLinkPaymentStatusTagType(item.status),
                                    iconType: getPayByLinkPaymentStatusIconType(item.status)
                                }}
                            >
                                <Text className={styles.listItemTitle}>
                                    {getAmountWithCurrentCurrency(item.amount)}
                                </Text>
                            </TitleWithStatus>
                        }
                        extra={
                            extra && (
                                <div onClick={(event) => event.stopPropagation()}>{extra}</div>
                            )
                        }
                        className={styles.listItem}
                        onClick={() => onItemClick?.(item)}
                    >
                        <Description
                            dataSource={[
                                {
                                    label: t('MobilePayByLinkPaymentList.description'),
                                    value: item.description,
                                    key: t('MobilePayByLinkPaymentList.description')
                                },
                                {
                                    label: t('MobilePayByLinkPaymentList.customer'),
                                    value: item.customer || item.customerName,
                                    key: t('MobilePayByLinkPaymentList.customer')
                                },
                                {
                                    label: t('MobilePayByLinkPaymentList.date'),
                                    value: item.date,
                                    key: t('MobilePayByLinkPaymentList.date'),
                                    render: () => <DateTimeLabel date={item.date} />
                                }
                            ]}
                        />
                    </Card>
                )
            }}
        />
    )
}
